(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hemkind-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hemkind-product-showcase')) {
    class HemkindProductShowcase extends HTMLElement {
      connectedCallback() {
        if (this._ready) {
          this._resizeObserver?.observe(this);
          return;
        }
        this._ready = true;
        this.tabs = Array.from(this.querySelectorAll('[data-hk-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-hk-panel]'));
        this.prev = this.querySelector('[data-hk-prev]');
        this.next = this.querySelector('[data-hk-next]');

        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.activate(index)));
        this.panels.forEach((panel) => panel.querySelector('[data-hk-track]')?.addEventListener('scroll', () => this.updateArrows(), { passive: true }));
        this.prev?.addEventListener('click', () => this.scrollCards(-1));
        this.next?.addEventListener('click', () => this.scrollCards(1));
        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          this.activate(nextIndex);
          this.tabs[nextIndex].focus();
        });
        this.addEventListener('shopify:block:select', (event) => {
          const selectedTab = event.target.closest('[data-hk-tab]');
          const index = this.tabs.indexOf(selectedTab);
          if (index >= 0) this.activate(index);
        });
        this._resizeObserver = new ResizeObserver(() => this.updateArrows());
        this._resizeObserver.observe(this);
        this.activate(0);
      }

      disconnectedCallback() { this._resizeObserver?.disconnect(); }

      activate(index) {
        if (!this.tabs?.length) return;
        this.activeIndex = index;
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[tabIndex].hidden = !active;
        });
        requestAnimationFrame(() => this.updateArrows());
      }

      scrollCards(direction) {
        const track = this.panels[this.activeIndex]?.querySelector('[data-hk-track]');
        if (!track) return;
        const card = track.querySelector('.hk-showcase__card');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
        track.scrollBy({ left: step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }

      updateArrows() {
        if (!this.prev || !this.next) return;
        const track = this.panels[this.activeIndex]?.querySelector('[data-hk-track]');
        this.prev.disabled = !track || track.scrollLeft <= 2;
        this.next.disabled = !track || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
    }
    customElements.define('hemkind-product-showcase', HemkindProductShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
